import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { saveAs } from 'file-saver';

import { ITrainingSessionUser, TrainingSessionUserService } from '../../services/GI.Web.Services.g';
import { RdpService } from '../../services/rdp.service';
import { ErrorHandling } from '../../ErrorHandling';

@Component({
  selector: 'app-training-user-detail',
  templateUrl: './training-user-detail.component.html',
  styleUrls: ['./training-user-detail.component.css']
})
export class TrainingUserDetailComponent implements OnInit {

  public studentId: string;
  public trainingSessionUser: ITrainingSessionUser;
  public trainingSessionUserReady = false;
  public messages: Message[] = [];

  constructor(
    private trainingSessionUserService: TrainingSessionUserService,
    private rdpService: RdpService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getStudentIdFromRoute();
  }

  async getStudentIdFromRoute() {
    // TODO: Can we use async with params?
    // const params = await this.route.paramMap.take(1).toPromise();
    // this.studentId = params['studentId'];
    // await this.getTrainingSessionUser();
    this.route.params.subscribe(async params => {
      this.studentId = params['studentId'];
      await this.getTrainingSessionUser();
    });
  }

  async getTrainingSessionUser() {
    try {
      this.trainingSessionUser = await this.trainingSessionUserService.get(this.studentId).toPromise();
    } catch (error) {
      this.messages = ErrorHandling.getErrorMessages(error);
    }
    this.trainingSessionUserReady = true;
  }

  downloadRdp() {
    if (this.trainingSessionUser.targetComputer && this.trainingSessionUser.targetComputer.ipAddress) {
      const rdpString = this.rdpService.buildRdpFileAsString(this.trainingSessionUser.targetComputer, this.trainingSessionUser.userName);
      const blob = new Blob([rdpString], { type: 'text/plain;charset=utf-8' });
      saveAs(blob, this.rdpService.setRdpFileName(this.trainingSessionUser.targetComputer));
    }
    else {
      this.messages = [];
      this.messages.push({
        severity: 'error',
        summary: 'Cannot download RDP File.',
        detail: 'VM is not ready or information is not known.'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/training-user-detail/training-user-detail.component.ts